import { render, staticRenderFns } from "./SMSPlatform.vue?vue&type=template&id=4c650f30&scoped=true"
import script from "./SMSPlatform.vue?vue&type=script&lang=js"
export * from "./SMSPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c650f30",
  null
  
)

export default component.exports